import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  useTheme,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  AdminToggleActiveIcon,
  AdminToggleInActiveIcon,
  BackIcon,
} from "../../../Svg";
import { headersGet, headersPost } from "../../../Services/API";
import { AdminUrls } from "../../../Services/Routes/API";
import { MainRoutes } from "../../../Services/Routes/App";
import InfoIcon from "@mui/icons-material/Info";

import DelModal from "../DelModal";

const WalletListing = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const tableOneHeadings = ["id", "User", "Email", "No of Wallets", "Details"];
  const tableTwoHeadings = [
    "id",
    "Email",
    "Wallet Name",
    "Freez Status",
    "Block Status",
  ];
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [product, setProduct] = useState([]);
  const [openFreezeModal, setOpenFreezeModal] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState(false);
  const [api, setApi] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [wallets, setWallets] = useState([]);
  const [pageData, setPageData] = useState([]);

  const useStyles = makeStyles({
    muiPaperShadowNone: {
      "& .MuiPaper-root": {
        boxShadow: "1px 1px 0px 2px rgb(217 217 217)",
        minWidth: "100px",
      },
    },
    tableBodyText: {
      fontWeight: "400",
      fontSize: "13px",
      lineHeight: "20px",
      color: "#959595",
    },
  });

  const getAdminUsers = () => {
    setOpen(true);
    headersGet(AdminUrls.GET_USERS_LISTING)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setUsers(res?.data?.users);
          const UPDATED_ARR = res?.data?.users.filter((user) => {
            return user.id === pageData?.id;
          });
          if (UPDATED_ARR.length) {
            setPageData(UPDATED_ARR[0]);
            setWallets(UPDATED_ARR[0].wallets);
          }
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  // wallet status handler

  const closeModalHandler = () => {
    setOpenBlockModal(false);
    setOpenFreezeModal(false);
  };
  const walletHandller = (pro) => {
    setPageData(pro);
    setWallets(pro?.wallets);
    setPageNumber(2);
  };

  const delProduct = (pro) => {
    setProduct(pro);
  };
  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };
  // handler
  const walletFreezeHandler = () => {
    const data = {
      wallet: {
        id: product?.id,
        is_archived: !product?.is_archived,
      },
    };
    setOpen(true);

    headersPost(AdminUrls.UPDATE_WALLET, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenFreezeModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setOpenFreezeModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const walletBlockHandler = () => {
    const data = {
      wallet: {
        id: product?.id,
        is_blocked: !product?.is_blocked,
      },
    };
    setOpen(true);

    headersPost(AdminUrls.UPDATE_WALLET, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenBlockModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setOpenBlockModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getAdminUsers();
  }, [api]);

  const classes = useStyles();

  return (
    <Box mt={6}>
      {pageNumber === 1 && (
        <Paper>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650, height: "200px" }}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {tableOneHeadings?.map((h, index) => {
                    {
                      return (
                        <TableCell
                          sx={{ fontWeight: "bold" }}
                          key={`${index}-table-heading-${h}`}
                        >
                          {h}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {users?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell className={classes.tableBodyText}>
                      {row?.id}{" "}
                    </TableCell>
                    <TableCell className={classes.tableBodyText}>
                      {row?.first_name} {row?.last_name}
                    </TableCell>
                    <TableCell className={classes.tableBodyText}>
                      {row?.email}
                    </TableCell>
                    <TableCell className={classes.tableBodyText}>
                      {row?.wallet_count}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        onClick={() => {
                          walletHandller(row);
                        }}
                        sx={{
                          borderRadius: 4,
                          minWidth: 0,
                          backgroundColor: "transparent",
                          padding: 0,
                        }}
                      >
                        <InfoIcon sx={{ color: "#11A1EC" }} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {pageNumber === 2 && (
        <Box>
          <Button
            sx={{
              padding: theme.spacing(0),
              height: "31px",
              minWidth: "31px",
              borderRadius: 6,
              marginBottom: 1,
            }}
            onClick={() => setPageNumber(1)}
          >
            <BackIcon />
          </Button>
          <Paper>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650, height: "200px" }}
                aria-label="simple table"
                stickyHeader
              >
                <TableHead>
                  {" "}
                  <TableRow>
                    {tableTwoHeadings?.map((h, index) => {
                      {
                        return (
                          <TableCell
                            sx={{ fontWeight: "bold" }}
                            key={`${index}-table-heading-${h}`}
                          >
                            {h}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {wallets?.length > 0 ? (
                    wallets?.map((row, index) => (
                      <TableRow key={`${index}-row.name-${index + 2}`}>
                        <TableCell className={classes.tableBodyText}>
                          {row?.id}{" "}
                        </TableCell>
                        <TableCell className={classes.tableBodyText}>
                          {row?.name}
                        </TableCell>
                        <TableCell className={classes.tableBodyText}>
                          {row?.email}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="none"
                            onClick={() => {
                              delProduct(row);
                              setOpenFreezeModal(true);
                            }}
                            size="small"
                            sx={{
                              padding: theme.spacing(0),
                              minWidth: "35px",
                              borderRadius: 3,
                            }}
                          >
                            {row?.is_archived ? (
                              <AdminToggleInActiveIcon />
                            ) : (
                              <AdminToggleActiveIcon />
                            )}
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="none"
                            onClick={() => {
                              delProduct(row);
                              setOpenBlockModal(true);
                            }}
                            size="small"
                            sx={{
                              padding: theme.spacing(0),
                              minWidth: "35px",
                              borderRadius: 3,
                            }}
                          >
                            {row?.is_blocked ? (
                              <AdminToggleInActiveIcon />
                            ) : (
                              <AdminToggleActiveIcon />
                            )}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow sx={{ paddingY: 0 }}>
                      {" "}
                      <TableCell colSpan={8}>
                        {" "}
                        <Typography
                          width={"100%"}
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          Record not found
                        </Typography>{" "}
                      </TableCell>{" "}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      )}
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <DelModal
        header={"Status"}
        status={product?.is_archived}
        open={openFreezeModal}
        handleClose={closeModalHandler}
        statusHandler={walletFreezeHandler}
      />
      <DelModal
        header={"Status"}
        status={product?.is_blocked}
        open={openBlockModal}
        handleClose={closeModalHandler}
        statusHandler={walletBlockHandler}
      />
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WalletListing;
